import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TypeChecker } from '../../../shared/classes/type-checker';

import { InputNumberModule } from 'primeng/inputnumber';
import { BaseControl } from '../../../shared/classes/form-base-controls';
import { InputNumberControl } from '../../../shared';

@Component({
  selector: 'app-number-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    InputNumberModule
  ],
  template: `
  <div [formGroup]="formGroup" *ngIf="typeChecker.isInputNumber(control)" class="w-full">
      <p-inputNumber inputStyleClass="w-full" styleClass="w-full" class="w-full"
        [formControlName]="control.name" 
        [attr.aria-describedby]="control.name + '-help'"
        [min]="control.min"
        [max]="control.max"
        [readonly]="control.readonly"></p-inputNumber>
      <div class="text-sm font-semibold" *ngIf="control.min !== undefined || control.max !== undefined">
        (@if(control.min !== undefined){
        Min: {{control.min}}
        }
        @if(control.min !== undefined && control.max !== undefined){
        -
        }
        @if(control.max !== undefined){
        Max: {{control.max}}
        })
      </div>
  </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `  
})
export class NumberControlComponent {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;

}
